/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import manageVisitModal from "../manageVisitModal/manageVisitModal.vue";
import VisitActivityModal from "../VisitActivityOrder/VisitActivityOrder.vue";
import showformmodel from "../showformmodel/showformmodel.vue"

export default {
    name: "ArmVisitActivityTree",
    components: {
        manageVisitModal,
        VisitActivityModal,
        showformmodel
    },

    data() {
        return {
            armList: [],
            currentArmCode: null,
            visitList: {},
            activityList: {},
            formList: {},
            showSiteModal: false,
            studyId: null,
            SelectedVisitId: null,
            selectedVersion: null,
            showActivityModal: false,
            baseurl: process.env.VUE_APP_Service_URL,
            token: store.getters.getIdToken,
            head: "",
            selectedArm: "",
            formActivityId: "",
            setshowActivityFormModal: false,
            previousRoute: null,
            currentVisitId: 0, 
            isEditing: false,
            isArmSpecific: false,
            studyDetails: {},
            versiondetailsobj: {}
        };
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.previousRoute = from.fullPath;
        });
    },
    async mounted() {

        window.addEventListener("studyIdChanged", async (event) => {
            console.log("StudyIDChanged into " + event.detail.storage);

            this.idToken = store.getters.getIdToken;

            this.head = {
                headers: {
                    Authorization: "Bearer " + this.idToken,
                    "Content-Type": "application/json",
                },
            };
            this.studyId = store.getters.getStudyIs;

            await this.getStudyDetails();
            this.selectedVersion = this.studyDetails.currentVersion;

            await this.getAllArm();
        });

        this.idToken = store.getters.getIdToken;
        this.head = {
            headers: {
                Authorization: "Bearer " + this.idToken,
                "Content-Type": "application/json",
            },
        };

        this.studyId = store.getters.getStudyIs;

        await this.getStudyDetails();
        this.selectedVersion = this.studyDetails.currentVersion;

        await this.getAllArm();
    },

    methods: {
        async getStudyDetails() {
            try {
                const res = await axios.get(
                    `${this.baseurl}/management/study/getbyid?id=${this.studyId}`,
                    this.head
                );
                this.studyDetails = res.data;
                this.versiondetailsobj = res.data;
                    const currentVersion = res.data.currentVersion;

                    const versionObj = res.data.versions.find(
                        v => v.version === currentVersion
                    );

                    this.isArmSpecific = versionObj ? versionObj.isArmSpecific : false;
                     this.routpage();
            } catch (err) {
                console.log("error in get study", err);
            }
        },
        async routpage() {
            if (this.$route.name !== "Scheduleofactivities") return;

            if (this.isArmSpecific) {
                this.$router.push("/Scheduleofactivities");
            } else {
                this.$router.push({
                    name: "visitInfo",
                    params: { version: this.selectedVersion }
                });
            }
        },


        async getAllArm() {
            try {
                const response = await axios.get(
                    `${this.baseurl}/fhir-service/arm/getarmsbystudyid?study_id=${this.studyId}`,
                    this.head
                );

                if (Array.isArray(response.data)) {
                    this.armList = response.data;

                    this.visitList = {};

                    this.armList.forEach((arm) => {
                        this.visitList[arm.ArmCode] = [];
                    });
                }
            } catch (err) {
                console.log("Failed to load arms", err);

                if (
                    err.response &&
                    err.response.data &&
                    err.response.data.detail === "No ARM items found for the given StudyId"
                ) {
                    this.armList = [];
                    this.visitList = {};
                    return;
                }

                this.armList = [];
                this.visitList = {};
            }
        },


        async toggleArm(armCode) {
            console.log("Arm clicked:", armCode);

            try {
                const response = await axios.get(
                    `${this.baseurl}/management/visit/listvisit?StudyId=${this.studyId}&ArmCode=${armCode}&StudyVersion=${this.selectedVersion}`,
                    this.head
                );

                this.visitList[armCode] = response.data.results || [];

                this.visitList[armCode].forEach(v => {
                    this.activityList[v.visitId] = [];
                });

            } catch (err) {
                console.log("Error loading visits for arm:", err);
            }
        },
        isFirstPhaseVisit(visits, phase, index) {
            return visits.findIndex(v => v.studyPhase === phase) === index;
        },

        async toggleVisit(armId, visitId) {
            console.log("Visit clicked:", visitId);

            try {
                const response = await axios.get(
                    `${this.baseurl}/management/visit/listvisitactivity?visitId=${visitId}`,
                    this.head
                );

                this.activityList[visitId] = response.data.entities || [];

                // Create empty form array for each activity
                this.activityList[visitId].forEach((a) => {
                    this.formList[a.activityId] = [];
                });

            } catch (err) {
                console.log("Error loading activities:", err);
            }
        },


        async toggleActivity(activityId, armCode) {
            console.log("Activity clicked:", activityId);

            try {
                const response = await axios.get(
                    `${this.baseurl}/management/study/getsoa?Id=${activityId}`,
                    this.head
                );

                this.formList[activityId + armCode] = response.data.eCRF || [];

            } catch (err) {
                console.log("Error loading forms:", err);
            }
        },

        handleCreateVisit(armCode) {
            const popup = document.getElementById(`arm-popup-${armCode}`);
            popup?.hidePopover?.();
            console.log("Creating visit for arm:", armCode);
            this.visitId = 0;
            this.currentArmCode = armCode;
            this.selectedArm = armCode;
            this.isEditing = false; // Set to false for create
            this.showSiteModal = true;

            console.log("Create mode - visitId:", this.currentVisitId, "armCode:", armCode);
        },

        closeModal() {
            this.showSiteModal = false;
        },
        closeActivitModal() {
            this.showActivityModal = false;
            this.toggleArm(this.currentArmCode);
        },

        openVisitActivityModal(visitid) {
            this.closeAllPopovers();
            this.SelectedVisitId = visitid;
            this.showActivityModal = true;
        },

        refreshVisitList() {
            this.toggleArm(this.currentArmCode);
        },

        async viewForms(tempId) {
            console.log("Form clicked:", tempId);
            this.formActivityId = tempId;
            this.setshowActivityFormModal = true;
        },

        closeformActivityModal() {
            this.setshowActivityFormModal = false;
        },

        closePage() {
            if (this.previousRoute) {
                this.$router.push(this.previousRoute);
            } else {
                this.$router.back();
            }
        },


        async deleteVisit(visitId) {
            this.closeAllPopovers();
            if (confirm(this.$t('navigations.are you sure you want to delete this visit?'))) {
                try {
                    await axios.delete(
                        `${this.baseurl}/management/visit/delete?id=${visitId}`,
                        this.head
                    );

                    alert(this.$t("navigations.visit deleted successfully"));
                    this.toggleArm(this.currentArmCode);
                } catch (err) {
                    alert(this.$t("navigations.failed due to internal error"));
                    console.error(err);
                }
            }
        },

        visitPopup(visitId, armCode) {
            this.closePopover(`visit-popup-${visitId}`);
            this.showSiteModal = true;
            this.visitId = visitId;
            this.currentArmCode = armCode;
        },
        closePopover(popoverId) {
            const popover = document.getElementById(popoverId);
            if (popover && typeof popover.hidePopover === 'function') {
                popover.hidePopover();
            }
        },

        closeAllPopovers() {

            this.armList.forEach(arm => {
                this.closePopover(`arm-popup-${arm.ArmCode}`);
            });

            Object.keys(this.visitList).forEach(armCode => {
                this.visitList[armCode].forEach(visit => {
                    this.closePopover(`visit-popup-${visit.visitId}`);
                });
            });
        }
    }
};
